import store from "../store/store";

const NotificacionMovimientosInventario = (movimientosIds) => {
  if (!Array.isArray(movimientosIds) || movimientosIds.length === 0) return;
  const state = store.getState();
  if (!state.empresa.mostrarPdfMovimientosInventario) return;
  if (typeof window.mostrarMovimientosInventarioPdf === "function") {
    window.mostrarMovimientosInventarioPdf(movimientosIds);
  }
};

export default NotificacionMovimientosInventario;
